/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCamperTrailer48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M36.91 41.26h5.44v3.52c0 .79-.64 1.43-1.43 1.43h-2.58c-.79 0-1.43-.64-1.43-1.43v-3.52zM11.15 41.26H5.71v3.52c0 .79.64 1.43 1.43 1.43h2.58c.79 0 1.43-.64 1.43-1.43v-3.52z'
      />
      <path
        fill='#D6F5FF'
        fillRule='evenodd'
        d='M28.74 2.31h-9.52c-5.04 0-10.19 1.94-13 5.25l-2.07 3.13c9.87-5.19 29.87-5.19 39.65 0l-2-3c-2.77-3.44-7.97-5.38-13.06-5.38zM45.03 40.5h-42v-5H15.1l.93 2h15.63l.77-2h12.6v5z'
      />
      <path
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.511}
        d='M2.97 16.01v24.8h42V15.98c0-5.48-3.3-10.46-8.37-12.34-6.57-2.46-18.57-2.46-25.24.02-5.07 1.88-8.39 6.86-8.39 12.35z'
      />
      <path
        fill='#D6F5FF'
        d='M32.03 11.4h-16v2h16v-2zM32.03 16.5h-16v2h16v-2z'
      />
      <path
        fill='currentColor'
        d='M30.93 12.13c.5 0 .93.43.93.93v6.24c0 .5-.43.93-.93.93h-13.8c-.5 0-.93-.43-.93-.93v-6.24c0-.5.43-.93.93-.93h13.8zm0-1.45h-13.8c-1.31 0-2.38 1.07-2.38 2.38v6.24c0 1.31 1.07 2.38 2.38 2.38h13.8c1.31 0 2.38-1.07 2.38-2.38v-6.24c0-1.31-1.07-2.38-2.38-2.38z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M15.91 16.18h16.24M3.03 24.18h42'
      />
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M23.93 28v18.25'
      />
      <path
        fill='#fff'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M22.43 37.5h-7v-2.84c0-1.19.97-2.16 2.16-2.16h2.68c1.19 0 2.16.97 2.16 2.16v2.84z'
      />
      <path
        fill='currentColor'
        d='M20.43 32h-3v-1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1zM30.43 32h-3v-1c0-.55.45-1 1-1h1c.55 0 1 .45 1 1v1z'
      />
      <path
        fill='#fff'
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M32.43 37.5h-7v-2.84c0-1.19.97-2.16 2.16-2.16h2.68c1.19 0 2.16.97 2.16 2.16v2.84z'
      />
      <path
        fill='#fff'
        d='M23.18 41.25c-.41 0-.75-.34-.75-.75v-10c0-.41.34-.75.75-.75h1.5c.41 0 .75.34.75.75v10c0 .41-.34.75-.75.75h-1.5z'
      />
      <path
        fill='currentColor'
        d='M24.68 30.5v10h-1.5v-10h1.5zm0-1.5h-1.5c-.83 0-1.5.67-1.5 1.5v10c0 .83.67 1.5 1.5 1.5h1.5c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5z'
      />
      <path
        fill='#fff'
        stroke='currentColor'
        strokeLinecap='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M37.96 37.61v2.89h-28v-2.89c0-.06.05-.11.11-.11h27.78c.06 0 .11.05.11.11z'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M22.93 46.25h2'
      />
      <path
        fill='#fff'
        stroke='currentColor'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M24.03 37.5c-1.1 0-2 .9-2 2v2h4v-2a2 2 0 00-2-2z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M28.44 26v2h-4.5'
      />
      <path
        fill='#fff'
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M23.97 7.89c.59 0 1.06-.48 1.06-1.06 0-.58-.48-1.06-1.06-1.06a1.06 1.06 0 000 2.12zM18.97 7.89c.59 0 1.06-.48 1.06-1.06 0-.58-.48-1.06-1.06-1.06a1.06 1.06 0 000 2.12zM28.97 7.89c.59 0 1.06-.48 1.06-1.06 0-.58-.48-1.06-1.06-1.06a1.06 1.06 0 000 2.12z'
      />
    </svg>
  );
}

export default SvgCamperTrailer48;
